export default "/images/check-icon.svg?8403f933fa63d53efbd81f064aa70cd7";